import type { Nullable } from '@/types'

type LinkedListNode = {
  id: string
  previousId: Nullable<number>
}

export const sortByPreviousId = <T extends LinkedListNode>(nodes: T[]) => {
  const nodeMap = new Map(nodes.map((node) => [node.previousId, node]))

  const result: T[] = []

  let nextNode = nodeMap.get(null)
  while (nextNode) {
    result.push(nextNode)
    nextNode = nodeMap.get(parseInt(nextNode.id, 10))
  }

  return result
}
